import * as React from "react";
import { memo } from "react";
const SvgTopArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 13, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m12 .5 12 12H0l12-12Z", fill: "currentColor" }));
const Memo = memo(SvgTopArrow);
export default Memo;
